import { NgClass } from '@angular/common';
import { Component, computed, HostBinding, input, output } from '@angular/core';
import { ButtonSize, Icon } from '@ui';
import { IconComponent } from '../icons/icon/icon.component';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  standalone: true,
  imports: [NgClass, IconComponent],
})
export class ButtonComponent {
  readonly label = input<string>();
  readonly loadingLabel = input<string>('Loading...');
  readonly icon = input<Icon | null>(null);
  readonly trailingIcon = input<Icon | null>(null);
  readonly isFullWidth = input<boolean>(false);
  readonly isDarkMode = input<boolean>(false);
  readonly htmlButtonType = input<HTMLButtonElement['type']>('button');

  readonly size = input<ButtonSize>('md');
  readonly variant = input<
    | 'primary'
    | 'secondary'
    | 'destructive'
    | 'tertiary'
    | 'quaternary'
    | 'link-color'
    | 'link-gray'
    | 'link-destructive'
  >('primary');
  readonly loading = input<boolean>(false);
  readonly disabled = input<boolean>(false);

  onClick = output<void>();

  onlyIconClass = computed(() => (this.icon() && !this.label() ? 'ui-button-only-icon' : ''));

  loadingClass = computed(() => (this.loading() ? 'ui-button-loading' : ''));

  disabledClass = computed(() => (this.disabled() ? 'ui-button-disabled' : ''));

  variantClass = computed(() => `ui-button-${this.variant()}`);

  sizeClass = computed(() => `ui-button-${this.size()}`);

  linkClass = computed(() => (this.variant().includes('link') ? 'ui-button-link' : ''));

  darkModeClass = computed(() => (this.isDarkMode() ? 'ui-button-dark' : ''));

  iconSize = computed(() => {
    if (this.size() === 'sm') {
      return 16;
    }

    return 20;
  });

  @HostBinding('class.w-full')
  get fullWidth() {
    return this.isFullWidth();
  }
}
